import { type CalendarDate, parseDate } from '@internationalized/date';
import { ensureFutureDateString } from './dateHelpers';

export const DEFAULT_TRIP_DURATION_DAYS = 7;

export type CalendarRange = { start: CalendarDate; end: CalendarDate };

function dayOffsetForTripDuration(tripDurationDays: number): number {
  return Math.max(tripDurationDays - 1, 0);
}

export function getTripDurationDaysFromStayNights(stayNights: number): number {
  return stayNights > 0 ? stayNights + 1 : DEFAULT_TRIP_DURATION_DAYS;
}

export function getSafeRange(
  startStr: string,
  endStr: string,
  defaultTripDurationDays: number = DEFAULT_TRIP_DURATION_DAYS
): CalendarRange {
  const safeStart = parseDate(ensureFutureDateString(startStr || null));
  if (startStr && endStr) {
    const originalStart = parseDate(startStr);
    const originalEnd = parseDate(endStr);
    const duration = Math.max(originalEnd.compare(originalStart), 1);
    return { start: safeStart, end: safeStart.add({ days: duration }) };
  }
  return {
    start: safeStart,
    end: safeStart.add({ days: dayOffsetForTripDuration(defaultTripDurationDays) })
  };
}
